var _desc, _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdioms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.2.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 100 100)",
    id: "a029ea01-2495-4c1e-9fd1-0f46ed60d4fc"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    x: -100,
    y: -100,
    rx: 0,
    ry: 0,
    width: 200,
    height: 200
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0 0 0 0 0)",
    id: "14f17815-bd2a-48a8-b274-da467d55c5bc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.95 0 0 0.95 100 100)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 69.98 79.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(240,240,240)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-169.98, -179.8)",
    d: "M 176.294 189.681 C 175.399 190.886 174.291 191.917 173.023 192.721 C 172.752 192.892 172.476 193.052 172.195 193.202 L 165.569 193.202 C 165.647 193.043 165.725 192.882 165.8 192.721 C 170.012 183.831 168.091 173.246 161.025 166.403 C 165.03 167.642 168.731 170.053 171.152 173.473 C 172.328 175.139 173.166 177.02 173.615 179.008 C 174.015 175.03 173.379 171.016 171.769 167.357 C 175.02 170.002 177.552 173.624 178.517 177.701 C 179.482 181.781 178.782 186.308 176.294 189.681 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 48.01 93.15)",
    id: "b35682e1-9f03-403a-b8b0-c3d37d0d1380-2132"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,61,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-148.01, -193.15)",
    d: "M 178.978 193.404 L 116.944 193.404 L 116.944 192.897 L 179.07 192.897 L 178.978 193.404 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -35.63 -23.25)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(108,99,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-64.37, -76.75)",
    d: "M 95.241 69.963 C 95.241 79.263 91.992 87.203 85.809 93.113 C 81.421 97.307 74.663 103.188 74.663 109.404 L 74.663 114.548 L 54.084 114.548 L 54.084 109.404 C 54.084 103.122 47.298 97.23 42.938 93.113 C 36.894 87.411 33.505 78.93 33.505 69.963 L 33.505 69.773 C 33.582 46.012 59.354 31.244 79.894 43.19 C 89.424 48.734 95.274 58.939 95.241 69.963 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -35.63 -23.18)",
    id: "ecc2cf6c-8ee8-498c-972d-3c77e28b77e9-2133"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,61,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-64.37, -76.82)",
    d: "M 74.663 115.271 C 74.263 115.271 73.94 114.947 73.94 114.548 L 73.94 109.404 C 73.94 103.357 79.904 97.711 84.258 93.59 C 84.621 93.248 84.971 92.915 85.309 92.592 C 91.333 86.833 94.517 79.008 94.517 69.965 C 94.517 53.061 81.277 39.819 64.374 39.819 L 64.288 39.819 C 47.728 39.839 34.294 53.234 34.23 69.794 L 34.23 69.962 C 34.23 78.82 37.584 87.066 43.435 92.589 C 43.731 92.868 44.039 93.157 44.354 93.452 C 48.766 97.582 54.807 103.238 54.807 109.404 L 54.807 114.548 C 54.807 115.105 54.206 115.451 53.723 115.173 C 53.501 115.045 53.362 114.807 53.362 114.548 L 53.362 109.404 C 53.362 103.864 47.586 98.457 43.367 94.506 C 43.049 94.208 42.742 93.919 42.442 93.638 C 36.305 87.843 32.785 79.215 32.785 69.963 L 32.785 69.79 C 32.834 52.449 46.958 38.374 64.287 38.374 L 64.375 38.374 C 81.73 38.284 95.871 52.279 95.962 69.634 C 95.963 69.744 95.963 69.854 95.962 69.965 C 95.962 79.411 92.623 87.597 86.307 93.635 C 85.969 93.959 85.616 94.294 85.252 94.638 C 81.088 98.58 75.384 103.977 75.384 109.404 L 75.384 114.548 C 75.384 114.947 75.061 115.271 74.661 115.271 L 74.663 115.271 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -35.63 23.33)",
    id: "b22bef41-3cd7-4c1e-881c-c9a642005cb0-2134"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(108,99,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-64.37, -123.33)",
    d: "M 71.233 124.536 L 57.514 124.536 C 56.588 124.536 56.008 123.532 56.472 122.731 C 56.687 122.358 57.084 122.128 57.514 122.128 L 71.233 122.128 C 72.16 122.128 72.739 123.131 72.275 123.933 C 72.06 124.307 71.664 124.536 71.233 124.536 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -35.63 31.55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,61,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-64.37, -131.55)",
    d: "M 65.849 132.598 L 62.895 132.598 C 61.87 132.6 60.864 132.321 59.985 131.792 C 59.717 131.636 59.591 131.316 59.68 131.018 C 59.762 130.713 60.038 130.501 60.354 130.503 L 68.391 130.503 C 68.706 130.501 68.984 130.713 69.065 131.018 C 69.154 131.316 69.028 131.636 68.76 131.792 C 67.88 132.321 66.874 132.6 65.849 132.598 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -35.63 27.58)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(63,61,86)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-64.37, -127.58)",
    d: "M 71.236 128.337 L 57.435 128.335 L 57.392 128.244 C 57.309 127.903 57.389 127.542 57.608 127.267 C 57.83 126.985 58.17 126.822 58.529 126.822 L 70.216 126.822 C 70.576 126.822 70.913 126.985 71.137 127.267 C 71.353 127.538 71.435 127.894 71.356 128.232 L 71.333 128.325 L 71.236 128.337 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -72.7 -64.11)",
    id: "e0eb6627-54a4-4797-861b-0d156b8b485b-2135"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(228,228,228)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-27.3, -35.89)",
    d: "M 32.459 41.597 C 32.168 41.597 31.886 41.491 31.667 41.299 L 21.333 32.279 C 20.641 31.662 20.876 30.528 21.755 30.237 C 22.156 30.104 22.595 30.191 22.916 30.465 L 33.25 39.487 C 33.948 40.096 33.724 41.232 32.848 41.532 C 32.722 41.575 32.592 41.597 32.459 41.597 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.26 -64.11)",
    id: "e13fc22b-cd18-4b6e-a2d4-df4b74c6b7e7-2136"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(228,228,228)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-99.74, -35.89)",
    d: "M 94.574 41.597 C 93.648 41.597 93.068 40.595 93.531 39.791 C 93.598 39.677 93.682 39.572 93.783 39.487 L 104.117 30.465 C 104.821 29.862 105.914 30.247 106.083 31.159 C 106.16 31.573 106.014 31.997 105.7 32.277 L 95.365 41.299 C 95.146 41.491 94.865 41.597 94.574 41.597 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -35.63 19.06)",
    id: "a74da646-4683-465e-97fe-dd817e7fc328-2137"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(108,99,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-64.37, -119.06)",
    d: "M 74.663 120.264 L 54.084 120.264 C 53.158 120.264 52.578 119.262 53.042 118.459 C 53.256 118.087 53.654 117.858 54.084 117.858 L 74.663 117.858 C 75.589 117.858 76.167 118.861 75.705 119.663 C 75.49 120.035 75.092 120.264 74.663 120.264 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -39.48 0.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-60.51, -100.99)",
    d: "M 63.867 88.825 L 59.588 114.548 L 57.146 114.548 L 61.492 88.432 C 61.644 87.517 62.729 87.11 63.445 87.699 C 63.777 87.972 63.939 88.402 63.867 88.825 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -31.28 0.99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-68.72, -100.99)",
    d: "M 72.092 114.548 L 69.649 114.548 L 65.37 88.825 C 65.217 87.912 66.112 87.176 66.981 87.501 C 67.383 87.653 67.675 88.007 67.745 88.432 L 72.092 114.548 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -35.63 -12.03)",
    id: "be3a5c8a-fbb4-472c-819b-e8dd06032f6a-2138"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-64.37, -87.97)",
    d: "M 56.552 87.966 C 56.552 87.302 57.09 86.764 57.756 86.764 L 70.991 86.764 C 71.918 86.764 72.497 87.766 72.033 88.569 C 71.818 88.941 71.422 89.17 70.991 89.17 L 57.756 89.17 C 57.09 89.17 56.552 88.631 56.552 87.966 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -35.63 -81.91)",
    id: "e9f776ed-f4b6-47dc-b212-c247d99ecb23-2139"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(228,228,228)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-64.37, -18.09)",
    d: "M 64.374 29.583 C 63.71 29.583 63.17 29.045 63.17 28.38 L 63.17 7.8 C 63.17 6.874 64.174 6.296 64.975 6.758 C 65.347 6.974 65.577 7.371 65.577 7.8 L 65.577 28.38 C 65.577 29.045 65.038 29.583 64.374 29.583 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 60.57 84.35)",
    id: "eba1f826-879a-4c25-b118-6bb025be95d0-2140"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,184,184)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-160.57, -184.35)",
    d: "M 162.747 190.037 L 159.797 190.037 L 158.394 178.656 L 162.748 178.656 L 162.747 190.037 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 58.74 90.99)",
    id: "f6694a1b-3521-46e6-aa9c-51f4297aac52-2141"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(47,46,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-158.74, -190.99)",
    d: "M 163.5 192.897 L 153.986 192.897 L 153.986 192.777 C 153.986 190.731 155.644 189.074 157.688 189.074 L 163.5 189.074 L 163.5 192.897 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 40.38 83.88)",
    id: "fae71c2d-33fb-45f7-8331-19b4de5eddc8-2142"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,184,184)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-140.38, -183.88)",
    d: "M 140.33 189.94 L 137.48 189.178 L 139.063 177.82 L 143.271 178.945 L 140.33 189.94 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 36.22 90.24)",
    id: "b3b10fd6-5fa4-49f3-8270-96ad6a3a1e0e-2143"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(47,46,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-136.22, -190.24)",
    d: "M 140.319 192.897 L 131.127 190.439 L 131.158 190.323 C 131.686 188.348 133.716 187.174 135.692 187.702 L 141.306 189.204 L 140.319 192.897 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 51.3 57.47)",
    id: "f6267da0-acb1-421a-9dac-5a6151c1f955-2144"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(47,46,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-151.3, -157.47)",
    d: "M 164.445 126.252 L 166.917 129.124 L 163.72 187.476 L 156.892 187.476 L 153.45 142.576 L 142.777 188.68 L 135.677 186.941 L 142.131 128.381 L 164.445 126.252 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 55.51 7.85)",
    id: "ea0dabd6-18d7-4484-8048-4cddc34702bd-2145"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-155.51, -107.85)",
    d: "M 143.782 88.579 L 150.58 85.168 L 161.035 85.351 L 170.032 89.955 L 164.913 115.52 L 167.125 128.849 C 158.578 131.029 149.631 131.102 141.05 129.064 L 140.981 129.048 C 140.981 129.048 146.062 111.016 143.899 105.515 L 143.782 88.579 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 55.75 -25.02)",
    id: "a75b604a-8411-40e9-b5d3-81fba8b6e00c-2146"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,184,184)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-155.75, -74.98)",
    d: "M 163.45 74.954 C 163.428 69.025 156.996 65.345 151.874 68.327 C 146.752 71.31 146.779 78.721 151.924 81.665 C 157.046 84.598 163.428 80.913 163.45 75.011 L 163.45 74.954 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 51.88 9.65)",
    id: "b97e8772-edf1-4d51-bb40-aaab108bf113-2147"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,184,184)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-151.87, -109.64)",
    d: "M 142.844 107.218 C 143.467 108.819 145.385 109.467 146.851 108.572 L 160.655 115.869 L 161.102 112.506 L 147.688 104.597 C 146.459 102.852 143.8 103.092 142.904 105.031 C 142.585 105.721 142.563 106.511 142.844 107.218 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 51.84 7.9)",
    id: "b7638692-4395-4c34-bc33-e4b41c888504-2148"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(254,184,184)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-151.84, -107.9)",
    d: "M 161.24 107.799 C 160.28 109.224 158.268 109.437 157.032 108.243 L 141.965 112.343 L 142.097 108.074 L 157.085 104.182 C 158.667 102.747 161.208 103.565 161.659 105.651 C 161.819 106.395 161.668 107.171 161.24 107.799 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 63.2 3.18)",
    id: "fb7d8996-2760-43c1-a9a4-d402d6d3756c-2149"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-163.2, -103.18)",
    d: "M 167.095 90.14 L 170.032 89.956 C 170.032 89.956 173.471 94.494 171.564 99.419 C 171.564 99.419 171.893 117.109 164.276 116.383 C 156.659 115.656 154.252 115.656 154.252 115.656 L 156.538 109.278 L 161.653 107.698 C 161.653 107.698 160.077 100.745 163.062 97.85 L 167.095 90.14 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 42.51 0.66)",
    id: "a9eb06d8-8cbf-43ab-991d-4f9eccd60edd-2150"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(230,230,230)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-142.51, -100.66)",
    d: "M 145.882 89.985 L 145.467 87.856 C 145.467 87.856 139.344 87.712 138.133 96.991 C 138.133 96.991 132.627 110.877 138.024 112.665 C 143.421 114.453 149.358 112.665 149.358 112.665 L 148.911 106.541 L 142.973 105.33 C 142.973 105.33 146.041 101.36 144.37 97.919 L 145.882 89.985 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 56.07 -26.58)",
    id: "ba7ab43e-494b-455d-a87f-0e0f24cb0a47-2151"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(47,46,65)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-156.07, -73.42)",
    d: "M 158.415 78.736 C 157.85 78.512 157.223 78.524 156.623 78.415 C 154.484 78.02 152.832 75.838 153.035 73.671 C 153.087 73.39 153.091 73.103 153.05 72.821 C 152.901 72.202 152.213 71.87 151.582 71.796 C 150.951 71.723 150.298 71.817 149.684 71.652 C 148.736 71.399 148.028 70.534 147.787 69.582 C 147.582 68.613 147.69 67.607 148.092 66.702 L 148.387 67.316 C 148.695 66.991 148.904 66.587 148.991 66.149 C 149.514 66.177 149.985 66.476 150.234 66.937 C 150.614 67.107 150.569 66.237 150.948 66.065 C 151.118 66.023 151.299 66.046 151.453 66.131 C 152.288 66.411 153.176 65.991 154.004 65.688 C 155.439 65.169 156.975 64.993 158.491 65.176 C 159.497 65.299 160.514 65.597 161.297 66.24 C 161.915 66.801 162.419 67.476 162.778 68.231 C 163.745 70.039 164.473 72.032 164.453 74.082 C 164.435 75.761 163.918 77.396 162.97 78.78 C 162.476 79.499 160.88 81.993 159.821 81.718 C 158.489 81.374 160.01 79.36 158.415 78.736 Z",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdioms);
export default __webpack_public_path__ + "static/media/idioms.4b7005d3a86a748fdd78ddf857248a4e.svg";
export { ForwardRef as ReactComponent };